import React, { useState } from 'react';
import { Key, Shield } from 'lucide-react';
import { ToastContainer, useToast } from '../../components/shared/Toast';
import {
  PasswordSecurityTab,
  TwoFactorAuthTab
} from '../../components/vendor/profile';

const VendorSettings = () => {
  const toast = useToast();
  const [activeTab, setActiveTab] = useState('password');

  const tabs = [
    { id: 'password', name: 'Password & Security', icon: Key, fullName: 'Password & Security' },
    { id: 'twofactor', name: 'Two-Factor Auth', icon: Shield, fullName: 'Two-Factor Authentication' }
  ];

  return (
    <>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Settings</h1>
          <p className="text-sm text-gray-600">Manage your security and authentication settings</p>
        </div>
      </div>

      {/* Tab Navigation - Responsive */}
      <div className="border-b border-gray-200 mb-4 sm:mb-8 overflow-x-auto">
        <nav className="-mb-px flex space-x-2 sm:space-x-8 min-w-max sm:min-w-0">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center py-2 px-2 sm:px-1 border-b-2 font-medium text-xs sm:text-sm whitespace-nowrap transition-colors ${
                  activeTab === tab.id
                    ? 'border-primary-500 text-primary-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <Icon className="w-4 h-4 sm:w-5 sm:h-5 mr-1 sm:mr-2 flex-shrink-0" />
                <span>{tab.name}</span>
              </button>
            );
          })}
        </nav>
      </div>

      {/* Tab Content - Responsive */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6 lg:p-8">
        {activeTab === 'password' && <PasswordSecurityTab />}
        {activeTab === 'twofactor' && <TwoFactorAuthTab />}
      </div>

      {/* Toast Container */}
      <ToastContainer 
        toasts={toast.toasts} 
        position="top-right"
        onRemove={toast.removeToast}
      />
    </>
  );
};

export default VendorSettings;

